import { render, staticRenderFns } from "./SANotificationsWrapper.vue?vue&type=template&id=36917cb6"
import script from "./SANotificationsWrapper.vue?vue&type=script&lang=js"
export * from "./SANotificationsWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports